import { GameId } from '@bg-shared/enums/GameId';
import {
    ICardGameRunItemPoker,
    IMappedRunItemCallback,
} from '@bg-shared/business/CurrentResult/interfaces';
import { PokerDealtTo } from '@bg-shared/enums/PokerDealtTo';
import { POKER_HANDS_COUNT } from '@bg-shared/constants/constants';
import { useCurrentResult } from './useCurrentResult';

const positionsMap: Record<PokerDealtTo, number> = {
    [PokerDealtTo.PLAYER_1]: 0,
    [PokerDealtTo.PLAYER_2]: 1,
    [PokerDealtTo.PLAYER_3]: 2,
    [PokerDealtTo.PLAYER_4]: 3,
    [PokerDealtTo.PLAYER_5]: 4,
    [PokerDealtTo.PLAYER_6]: 5,
    [PokerDealtTo.BOARD]: POKER_HANDS_COUNT * 2,
};

const mapData: IMappedRunItemCallback<ICardGameRunItemPoker> = (entry) => {
    const item = entry.item as ICardGameRunItemPoker;

    return {
        item,
        order:
            item.dealtTo !== PokerDealtTo.BOARD
                ? (item.position - 1) * POKER_HANDS_COUNT + positionsMap[item.dealtTo]
                : item.position + positionsMap[item.dealtTo],
    };
};

export const useCurrentCardResultPoker = (drawCode: string, delay = 0): ICardGameRunItemPoker[] =>
    useCurrentResult<ICardGameRunItemPoker>(GameId.POKER, drawCode, delay, mapData);
